import React from "react";

const AuthSkeleton: React.FC = () => (
  <div className="flex flex-col h-screen overflow-hidden animate-pulse">
    {/* navbar */}
    <div className="h-16 bg-[#1d365d] flex-shrink-0" />
    <div className="flex flex-1 overflow-hidden bg-[#1d365d]">
      {/* sidebar */}
      <div className="w-64 bg-[#1d365d] flex-shrink-0 hidden lg:flex flex-col px-4 py-6 gap-3">
        <div className="h-4 bg-white/10 rounded w-3/4 mb-2" />
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-9 bg-white/10 rounded-lg" />
        ))}
      </div>
      {/* main content */}
      <main className="flex-1 bg-[#f8fafc] lg:rounded-tl-[20px] p-6 space-y-4">
        <div className="h-6 bg-gray-200 rounded w-1/3" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="bg-white rounded shadow p-5 h-24" />
          ))}
        </div>
        <div className="bg-white rounded shadow h-64" />
      </main>
    </div>
  </div>
);

export default AuthSkeleton;
